import React, { useEffect, useMemo } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, { PaginationProvider } from 'react-bootstrap-table2-paginator';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../../_redux/hewan-kurban-campaign/hewanKurbanCampaignAction';
import * as uiHelpers from '../HewanKurbanCampaignUIHelpers';
import { currencyFormatter } from '../../../../../../../_metronic/_helpers';


import {
    getHandlerTableChange,
    NoRecordsFoundMessage,
    PleaseWaitMessage,
} from '../../../../../../../_metronic/_helpers';
import * as columnFormatters from './column-formatters';
import { Pagination } from '../../../../../../../_metronic/_partials/controls';
import { useHewanKurbanCampaignUIContext } from '../HewanKurbanCampaignUIContext';
import { RoleChecker } from '../../../../../../RoleChecker';
// import { ToastContainer } from 'react-toastify';

const HewanKurbanCampaignTable = (props) => {
    // HewanKurbanCampaign UI Context
    const hewanKurbanCampaignUIContext = useHewanKurbanCampaignUIContext();
    const hewanKurbanCampaignUIProps = useMemo(() => {
        return {
            queryParams: hewanKurbanCampaignUIContext.queryParams,
            setQueryParams: hewanKurbanCampaignUIContext.setQueryParams,
            openEditHewanKurbanCampaignPage: hewanKurbanCampaignUIContext.openEditHewanKurbanCampaignPage,
        };
    }, [hewanKurbanCampaignUIContext]);


    // Getting curret state of hewanKurbanCampaign list from store (Redux)
    const { currentState } = useSelector(
        (state) => ({ currentState: state.hewanKurbanCampaigns }),
        shallowEqual,
    );

    const { totalCount, entities, listLoading } = currentState;

    const dispatch = useDispatch();
    useEffect(() => {

        //Requset ke Branch Action
        dispatch(actions.fetchHewanKurbanCampaigns(hewanKurbanCampaignUIProps.queryParams));

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hewanKurbanCampaignUIProps.queryParams, dispatch]);

    const allowEdit = RoleChecker('Edit', 'hewan_kurban_campaign')

    // Table columns
    const columns = [
        // {
        //     dataField: 'uuid',
        //     text: 'UUID',
        // },
        {
            dataField: 'name',
            text: 'Nama',
        },
        {
            dataField: 'price',
            text: 'Harga',
            formatter: (cell, row) => {
                return currencyFormatter(cell)
            }
        },
        {
            dataField: 'thk_livestock.name',
            text: 'Hewan Kurban',
        },
        // {
        //     dataField: 'branch',
        //     text: 'Cabang',
        //     formatter: (cell, row) => {
        //         if (cell) {
        //             return `${cell.name}`
        //         } else {
        //             return "-"
        //         }
        //     }
        // },
        {
            dataField: 'thk_livestock.thk_period.name',
            text: 'Periode',
        },
        {
            dataField: 'action',
            text: 'Actions',
            formatter: columnFormatters.ActionsColumnFormatter,
            formatExtraData: {
                openEditHewanKurbanCampaignPage: hewanKurbanCampaignUIProps.openEditHewanKurbanCampaignPage,
                allowEdit
            },
            classes: 'text-right pr-0',
            headerClasses: 'text-right pr-3',
            style: {
                minWidth: '100px',
            },
        },
    ];

    // Table pagination properties
    const paginationOptions = {
        custom: true,
        totalSize: totalCount,
        sizePerPageList: uiHelpers.sizePerPageList,
        sizePerPage: hewanKurbanCampaignUIProps.queryParams.pageSize,
        page: hewanKurbanCampaignUIProps.queryParams.pageNumber,
    };

    return (
        <>
            <PaginationProvider pagination={paginationFactory(paginationOptions)}>
                {({ paginationProps, paginationTableProps }) => {
                    return (
                        <Pagination
                            isLoading={listLoading}
                            paginationProps={paginationProps}
                        >
                            <BootstrapTable
                                wrapperClasses="table-responsive"
                                classes="table table-head-custom table-vertical-center overflow-hidden"
                                bootstrap4
                                bordered={false}
                                remote
                                keyField="uuid"
                                data={entities === null ? [] : entities}
                                columns={columns}
                                // defaultSorted={uiHelpers.defaultSorted}
                                onTableChange={getHandlerTableChange(
                                    hewanKurbanCampaignUIProps.setQueryParams,
                                )}
                                // selectRow={getSelectRow({
                                //   entities,
                                //   ids: productsUIProps.ids,
                                //   setIds: productsUIProps.setIds,
                                // })}
                                {...paginationTableProps}
                            >
                                <PleaseWaitMessage entities={entities} />
                                <NoRecordsFoundMessage entities={entities} />
                            </BootstrapTable>
                        </Pagination>
                    );
                }}
            </PaginationProvider>
        </>
    );
};

export default HewanKurbanCampaignTable;
